import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sets page <title> and <meta name="description"> per route.
 * Lightweight alternative to react-helmet-async — sufficient for crawlers that
 * execute JS (Google, Bing, Semrush JS-render). Restores defaults on unmount.
 *
 * Usage at top of any page component:
 *   <PageMeta title="Login · HeDesk" description="Log in to manage..." />
 */
const SITE = "HeDesk";
const DEFAULT_TITLE = "HeDesk — Patient Manager for Indian Clinics";
const DEFAULT_DESC = "HeDesk — Patient appointment & record manager for Indian clinics";

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function PageMeta({ title, description, canonical }) {
  const location = useLocation();
  useEffect(() => {
    const prevTitle = document.title;
    const prevDesc = (document.querySelector('meta[name="description"]') || {}).content;
    document.title = title || DEFAULT_TITLE;
    setMeta("description", description || DEFAULT_DESC);
    if (canonical) {
      setCanonical(canonical);
    } else if (typeof window !== "undefined") {
      setCanonical(`https://hedesk.help${location.pathname}`);
    }
    return () => {
      document.title = prevTitle || DEFAULT_TITLE;
      if (prevDesc) setMeta("description", prevDesc);
    };
  }, [title, description, canonical, location.pathname]);
  return null;
}
